module.exports = __webpack_public_path__ + "img/19-1.d943d4c0.jpg";